import axios from 'axios'
import { Message } from 'element-ui'
import store from '../src/store'
import router from './router'

// 创建axios实例
const instance = axios.create({
    withCredentials: true,
    // 请求超时时间
    timeout: 50000
})

instance.interceptors.request.use(async config => {
    config.headers["requestClient"]="YEZI_PC";
    if (config.url.indexOf("/user/") < 0) {
        await $util.security.isLogin();
        return config;
    }else {
        return config;
    }
}, error => {
    loadinginstace.close()
    Message.error({
        message: '加载超时'
    });
    return Promise.reject(error)
});


// respone拦截器
instance.interceptors.response.use((resp) => {
    return resp;
}, (error) => {
    if (error.response) {
        switch (error.response.status) {
            case 308:
                const redirectUrl = error.response.headers['authentication-redirecturl'];
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
                break;
            //未登录
            case 401:
                document.cookie =
                    "_authenticationTokenValue=''"+
                    ';expires=' +
                    new Date(0).toUTCString() +
                    ';domain=' +
                    $util.security.getDomain()+
                    ';'+ 'path=/';
                document.cookie =
                    "AuthInfo=''"+
                    ';expires=' +
                    new Date(0).toUTCString() +
                    ';domain=' +
                    $util.security.getDomain()+
                    ';'+ 'path=/';
                store.dispatch('clearGlobal');
                store.dispatch('clearHeadTab');
                store.dispatch('clearInclude');
                store.dispatch('clearRecords')
                router.push({name:"login"});
                break;
            //已登录但没有权限
            case 403:
                Message({
                    message: "Sorry,you do not have permission for access this resource",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            //没有找到页面
            case 404:
                Message({
                    message: "Sorry,the resource is not found",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            //后台报错
            case 400:
            case 422:
                Message({
                    message: error.response.data.message,
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            case 500:
                Message({
                    message: error.response.data.message,
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            default:
                Message({
                    message: "Sorry, server error.",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
        }
    }
    return Promise.reject(error)
})

export default instance


// WEBPACK FOOTER //
// ./src/http.js